module.exports = __webpack_public_path__ + "static/img/404.ba00b810.svg";